import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from "@angular/core";
import {
  PlayerAdjustmentService,
  FeeColumnFilterPanelService,
  ClubMemberService
} from "../../../../services";
import * as lodash from "lodash";
import { AlertService } from "../../../../services/alert.service";
import { StorageUtil } from "../../../../store";

@Component({
  selector: "app-jl-update-payment-plan",
  templateUrl: "./jl-update-payment-plan.component.html",
  styleUrls: ["./jl-update-payment-plan.component.css"]
})
export class JlUpdatePaymentPlanComponent implements OnInit, OnChanges {
  @Input() clubUserProgramFeeID: number;
  @Output() refreshEmitter = new EventEmitter<boolean>();

  today = new Date();
  totalAmountOfPayment: number;

  plans: any[];
  loading: boolean;
  updatingpayment: boolean;

  constructor(
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private playerAdjustmentService: PlayerAdjustmentService,
    private clubMemberService: ClubMemberService,
    private _alertService: AlertService
  ) {}

  ngOnInit() {}

  ngOnChanges(data) {
    if (data.clubUserProgramFeeID && this.clubUserProgramFeeID) {
      this.pullData();
    }
  }

  pullData() {
    this.playerAdjustmentService
      .getAllClubUserPaymentPlans(this.clubUserProgramFeeID)
      .subscribe(plans => {
        this.plans = plans;
        this.totalAmountOfPayment =
          lodash.sumBy(this.plans, "dueAmount") +
          lodash.sumBy(this.plans, "paidAmount");
        console.log("Plans - ", plans);
      });

    // this.clubMemberService
    //   .getClubPaymentUserFeePlan(this.userId, this.clubProgramId)
    //   .subscribe((data: any) => {
    //     console.log("getClubPaymentUserFeePlan - ", data);
    //     this.userNextPaymentDueList = data;
    //   });
  }

  removePayment(index: number) {
    // this.plans.splice(index, 1);
    this.updateNumberOfPayments(0, index, true);
  }

  updateNumberOfPayments(amount: number, index: number, remove = false) {

    if (this.updatingpayment) {
      console.log('checking flag', this.updatingpayment);
      return;
    }

    this.updatingpayment = true;
    const unpaidAmount =
      lodash.sumBy(this.unpaidPlans, x => x.dueAmount) - amount;

    if (amount === this.plans[index].dueAmount) {
      if (remove) {
        this.plans.splice(index, 1);
      }
      this.updatingpayment = false;
      return;
    }

    if (unpaidAmount) {
      const newAmount = +(unpaidAmount / (this.unpaidPlans.length - 1)).toFixed(2);

      let amountAdded = unpaidAmount;
      const changingPlans = this.plans.filter(
        (x, idx) => index !== idx && !x.isPaid
      );

      changingPlans.forEach((p, idx) => {
        if (idx === changingPlans.length - 1) {
          p.dueAmount = amountAdded;
        } else {
          p.dueAmount = newAmount;
          amountAdded = amountAdded - p.dueAmount;
        }

        console.log(idx, p);
        console.log(amountAdded);
      });
    }

    this.plans[index].dueAmount = amount;
    if (remove) {
      this.plans.splice(index, 1);
    }

    setTimeout(() => {
      console.log('setting flag false');
      this.updatingpayment = false;
    }, 1000);

  }

  addPayment() {
    this.plans.push({
      amount: 0,
      dueAmount: 0,
      discountAmount: 0,
      scholarshipAmount: 0,
      playerDiscountAmount: 0,
      creditAmount: 0,
      dueDate: new Date(),
      paid: false,
      clubUserProgramFeeID: this.clubUserProgramFeeID
    });
  }

  get unpaidPlans() {
    console.log("Unpaid plans - ", this.plans.filter(x => !x.isPaid));
    return this.plans.filter(x => !x.isPaid);
  }

  onSubmit() {
    this.loading = true;

    console.log('unpaidPlans', this.unpaidPlans);

    this.playerAdjustmentService
      .updateClubUserPaymentPlans(
        this.clubUserProgramFeeID,
        this.unpaidPlans.map(p => ({
          amount: p.dueAmount,
          paidAmount: p.paidAmount,
          clubUserPaymentPlanID: p.clubUserPaymentPlanID || 0,
          dueDate: new Date(p.dueDate).toLocaleDateString(),
          updatedBy: StorageUtil.userID,
          discountAmount: p.discountAmount,
          scholarshipAmount: p.scholarshipAmount,
          playerDiscountAmount: p.playerDiscountAmount,
          creditAmount: p.creditAmount,
          clubUserProgramFeeID: this.clubUserProgramFeeID
        }))
      )
      .subscribe(
        data => {
          this.closeSideOverlay();
          this._alertService.success(data.result);
          this.refreshEmitter.emit(true);

          this.loading = false;
        },
        error => {
          this.loading = false;

          if (typeof error.error === "string") {
            this._alertService.error(error.error);
          } else {
            this._alertService.error("Due Date is a required field");
          }
          this.refreshEmitter.emit(false);
        }
      );
  }

  onCancel() {
    this.closeSideOverlay();
    this.pullData();
  }

  closeSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  onPlanDateChange(event, plan) {
    plan.dueDate = new Date(event.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/jl-update-payment-plan/jl-update-payment-plan.component.ts